import { ErrorMessage, Field, useFormikContext } from 'formik';
import React from 'react';
import CurrencyInput from './CurrencyInput.jsx';

export default function ValorBase() {
    const { values } =useFormikContext();

    return <>
        <Field
            maskOptions={{ integerLimit:4,
                thousandsSeparatorSymbol: '' }}
            as={CurrencyInput}
            name="valorBase"
            disabled={values.atualizarSomenteValorDesconto || values.atualizarSomenteStatus}
            id="valorBase"
            placeholder="Valor Base"
        />
        <ErrorMessage
            component="span"
            name="valorBase"
            style={{ color: 'red' }}
        />
    </>;
}
